import React, { useState, useRef, useEffect, useCallback } from "react";
import { Avatar, Button, Dropdown, Select, Spin, Tag, Tooltip, Upload, message } from "antd";
import Modal from "react-modal";
import "./chat.css";
import bot from "../../assets/bot.png";
import ReactMarkdown from "react-markdown";
import profilePic from "../../assets/profile_pic.png";
import AAPALOGO from "../../assets/aapaNewlogoTm.png";
import clairaLogo from "../../assets/clairaLogo.jpeg";
import clairaLogoSvg from "../../assets/ClairaAdvAvatar.svg";

import {
  SendOutlined,
  PaperClipOutlined,
  MoreOutlined,
  CloseOutlined,
  LogoutOutlined,
  MinusOutlined,
  MessageOutlined,
  FormOutlined,
  InboxOutlined,
  CheckCircleOutlined,
  BarChartOutlined,
  WechatOutlined,
  WechatWorkOutlined,
  UploadOutlined,
  DownOutlined,
} from "@ant-design/icons";

import axios from "axios";
// import useChatSocket from '../../hooks/useBotListener.js'
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import rehypeSanitize from "rehype-sanitize";
import Carousel from "../carousel/Carousel";
import { store } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsBotTyping,
  setIsUserTyping,
  setMessages,
} from "../../redux/reducer/chatReducer";
import { Ai_Base_Url, BE_HOST, CHAT_BASE_URL } from "../../config/config";
import { Loader, MessageCircle } from "lucide-react";
import { axiosInstance } from "../../utils/axiosInterceptor";
// import  useChatSessionTimeout  from "../../hooks/useChatSessionTimeout.js";


const StaticAccounts = ({ selectedAccounts = [], accountMap }) => {
  const items = selectedAccounts.map((acctId) => ({
    key: acctId,
    label: accountMap[acctId] || acctId,
    disabled: true,
  }));

  return (
    <div className="w-full flex justify-end">
      <Dropdown
        // menu={{ items }}
        trigger={["click"]}
        placement="bottomRight"
        overlayClassName="static-accounts-dropdown"
        menu={{
         items,
         style: {
           maxHeight: "200px",
           overflowY: "auto",
         },
      }}
      >
        <div
          style={{
            minWidth: "250px",
            border: "1px solid #fff",
            borderRadius: "6px",
            padding: "2px 12px",
            color: "#fff",
            cursor: "pointer",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            fontSize:"16px"
          }}
        >
          <span>Current Selected Accounts</span>
          <DownOutlined />
        </div>
      </Dropdown>
    </div>
  );
};

const Chat = ({ open, setOpen, isSupport, allAcounts }) => {
  const [inputValue, setInputValue] = useState("");
  const chatContainerRef = useRef(null);
  const [isAtBottom, setIsAtBottom] = useState(true);
  const [autoScroll, setAutoScroll] = useState(true);
  const messagesContainerRef = useRef(null);
  const prevMessageCountRef = useRef(0);
  const [lang, setLang] = useState("en");
  const [isImageAttach, setIsAttachImage] = useState(false);
  const [choiceSelections, setChoiceSelections] = React.useState({});
  const [attchedImage, setAttachedImage] = useState("");
  const [chatVisible, setChatVisible] = useState(false);
  const [talkToAgent, setTalkToAgent] = useState(false);
  const [rocketchatMessages, setRocketChatMsg] = useState([]);
  const [inputValueSupport, setInputValueSupport] = useState("");
  const [chatSession, setChatSession] = useState({});
  const [supportSession, setSupportSession] = useState({
    rid: "",
    field_key: "",
    supplier_id: "",
    input_type: "",
  });
  const dispatch = useDispatch();
  const isBotTyping = useSelector((state) => {
    return state.chats?.isBotTyping;
  });
  const isUserTyping = useSelector((state) => {
    return state.chats?.isUserTyping;
  });
  const UserId = JSON.parse(localStorage.getItem("VisitorID"));
  const RoomId = JSON.parse(localStorage.getItem("RoomId"));
  const Authtoken = JSON.parse(localStorage.getItem("AuthToken"));
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const isAgentActive = JSON.parse(localStorage.getItem("isAgentActive"));
  const supplierId = JSON.parse(localStorage.getItem("supplierId"));
  const baseAcctId = JSON.parse(localStorage.getItem("baseAcctId"));
  const ChatRoomID = JSON.parse(localStorage.getItem("chatRoomId"));
  const [checkboxValues, setCheckboxValues] = useState({});
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [isAccountChanged,setIsAccountChanged] = useState(false)
  const [supportChat, setSupportChat] = useState([
    {
      type: "question",
      message:
        "Hi there! I'm Claira, the AdvantEdge Intelligence Assistant. I'm here to help you today. To better assist you, I'll need some information from your side. Please provide the requested details, and I'll guide you through the process.",
      ts: new Date(),
      input_type: "greeting_msg",
      options: [],
      field_key: "",
    },
  ]);
  const [file, setFile] = useState(null);
  const thinkingMessages = [
  "Claira is thinking",
  "Claira is processing",
  "Claira is analyzing your request",
  "Claira is working on it",
  "Claira is preparing a response",
  "Claira is formulating a response",
  "Claira is deep thinking",
];

const [thinkingText, setThinkingText] = useState(
  thinkingMessages[0]
);

useEffect(() => {
  if (!isBotTyping) return;

  let index = 0;

  const interval = setInterval(() => {
    index = (index + 1) % thinkingMessages.length;
    setThinkingText(thinkingMessages[index]);
  }, 1800);

  return () => clearInterval(interval);
}, [isBotTyping]);

  const handleFileChange = async (e) => {
    const supplier = supplierId || supportSession?.supplier_id || "46";
    const pharmacyNo = baseAcctId || SelectedPharmacy?.at(-1);
    const selectedFile = e.target.files?.[0];
    if (!selectedFile) return;
    setIsAttachImage(true);

    const formData = new FormData();

    formData.append("file", selectedFile);
    formData.append("document_type", supportSession?.field_key);
    if (selectedFile) {
      try {
        const response = await axios.post(
          `${CHAT_BASE_URL}/api/suppliers/${pharmacyNo}/supplier/${supplier}/onboarding/upload-document`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );
        if (response?.data) {
          //   setSupportChat((prev) => [
          //   ...prev,
          //   {
          //     type: "question",
          //     message: "File Uploaded SuccessFully.",
          //     ts: new Date(),
          //     input_type : "text",
          //     options:[],
          //     field_key: ""
          //   },
          // ]);
          await getSupportAiChat(
            response?.data?.data?.file_url,
            supportSession?.field_key,
            supportSession?.rid,
            supportSession?.supplier_id,
            true,
          );
        }
      } catch (error) {
        console.log(error, "Erroro");
      }
      setFile(selectedFile);
    }
  };
  const SelectedPharmacy = useSelector((state) => {
    return state.pharmacyData?.pharmacyData;
  });
  const pharmacylabel = useSelector((state) => {
    return state.pharmacyData?.pharmacyLabel;
  });
  // const messages = useSelector((state) => {
  //   return state.chats?.messages;
  // });
  const idleTimerRef = useRef(null);

  const [messages, setMessages] = useState([
    // {
    //   message_id: "",
    //   msg: "Hello! how can I help you today",
    //   rid: "",
    //   ts: new Date().toISOString(),
    //   u: {
    //     _id: "bot_id",
    //     name: "bot",
    //     username: "bot",
    //   },
    // },
  ]);

  const messagesEndRef = useRef(null);
  const rocketMessagesEndRef = useRef(null);
  const supportMessagesEndRef = useRef(null);
  const prevRocketMessageCountRef = useRef(0);
  const prevSupportMessageCountRef = useRef(0);
  const fileInputRef = useRef(null);
  const [inputValueCheck, setInputValueCheck] = useState(null);
  const prevPharmacyRef = useRef([]);

  const scrollToBottom = () => {
    messagesEndRef?.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleMultiSelect = (option) => {
    let updated = [];

    if (selectedOptions?.includes(option)) {
      updated = selectedOptions?.filter((item) => item !== option);
    } else {
      updated = [...selectedOptions, option];
    }

    setSelectedOptions(updated);

    // input me show karna
    setInputValue(updated.join(", "));
  };

    const handleClose = () => {
    setOpen(false);
    localStorage.removeItem("AuthToken");
    localStorage.removeItem("RoomId");
    localStorage.removeItem("VisitorID");
    localStorage.removeItem("chatRoomId")
    setMessages([]);
    setRocketChatMsg([]);
    dispatch(setIsBotTyping(false));
  };

  const handleChatLogin = async () => {
    const data = {
      email: userInfo?.user?.email,
      name: pharmacylabel,
      phone: userInfo?.user?.phone,
      accountnumber: JSON.stringify(SelectedPharmacy?.at(-1)),
      botRid: RoomId,
      accountname: pharmacylabel,
      // email: userInfo?.user?.email,
      // username: userInfo?.user?.first_name,
      // password: "abc@2025",
      // name:pharmacylabel,
      // accountname: pharmacylabel,
      // accountnumber: JSON.stringify(SelectedPharmacy?.at(-1)),
    };
    try {
      const response = await axios.post(`${CHAT_BASE_URL}/auth/userAuth`, data, {
        headers: { "Content-Type": "application/json" },
      });
      localStorage.setItem("AuthToken", JSON.stringify(response?.data?.token));
      localStorage.setItem(
        "VisitorID",
        JSON.stringify(response?.data?.visitor?._id),
      );
      // localStorage.setItem("chatRoomId", JSON.stringify(response?.data?.room?._id));
      setChatVisible(true);
      getAllMessage(response?.data);
      setTalkToAgent(false);
    } catch (error) {
      console.log(error, "errorrr");
    } finally {
    }
  };

  const getAllMessage = async (data) => {
    // const chatNewRoomID = data?.room?._id || ChatRoomID;
    // if (!chatNewRoomID) {
    if (!RoomId) {
      localStorage.removeItem("AuthToken");
      localStorage.removeItem("RoomId");
      localStorage.removeItem("VisitorID");
      localStorage.removeItem("chatRoomId")
      getAllAiMessages();
      return;
    }
    try {
      const response = await axios.get(
        `${CHAT_BASE_URL}/room/${RoomId}/history`,
        {
          params: {
            token: data?.token || Authtoken,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      // store.dispatch(setMessages(response?.data?.messages));
      // setMessages(prev => [...prev, ...response?.data?.messages]);
      setRocketChatMsg(response?.data?.messages);
    } catch (error) {
      console.error(
        "Error fetching messages:",
        error?.response?.data?.message || error?.message,
      );
    } finally {
      store.dispatch(setIsBotTyping(false));
    }
  };

  useEffect(()=>{
    const prev = prevPharmacyRef.current;

  const isChanged =
    prev.length !== SelectedPharmacy.length ||
    prev.some((item, index) => item !== SelectedPharmacy[index]);

  if (isAccountChanged && isChanged && !UserId) {
    console.log("Pharmacy Changed");
    handleSend("chatsupport2", true);
  }
  prevPharmacyRef.current = [...SelectedPharmacy];
  },[SelectedPharmacy])

  const handleSend = (item, flag) => {
    if (!inputValue?.trim() && !item) return;
    // resetIdleTimer();
    dispatch(setIsUserTyping(true));
    const messageToSend = inputValue || item?.label || item;
    setInputValue("");
    if (UserId) {
      getChat(messageToSend);
    } else {
      AiChatSend(messageToSend, flag);
    }
    setTimeout(scrollToBottom, 100);
  };

  const AiChatSend = async (msg, flag) => {
    if (!flag) {
      dispatch(setIsBotTyping(true));
    }
    const newMsg = {
      message_id: "",
      msg: msg,
      rid: "",
      ts: new Date().toISOString(),
      u: {
        _id: "",
        name: userInfo?.user?.first_name,
        username: userInfo?.user?.email,
      },
    };
    if (!flag) {
      setMessages((prevMessages) => [...prevMessages, newMsg]);
    }
    const roomId = RoomId ? RoomId : "";
    const payload = {
      question: msg,
      primary_account_id: SelectedPharmacy,
      rid: RoomId,
      user_id: userInfo?.user?.id,
      username: userInfo?.user?.email,
      name: userInfo?.user?.first_name,
    };
    try {
      const response = await axiosInstance.post(`${CHAT_BASE_URL}/ask-sql`, payload, {
        timeout: 90000, // 1.5 minutes
        // headers: {
        //   "Content-Type": "application/json",
        // },
      });
      dispatch(setIsUserTyping(false));
      // dispatch(setIsBotTyping(true));
      if (!RoomId) {
        localStorage.setItem(
          "RoomId",
          JSON.stringify(response?.data?.data?.data?.rid),
        );
      }
      setTalkToAgent(response?.data?.data?.talk_to_agent);
      getAllAiMessages(response?.data?.data?.data);
    } 
    // catch (error) {
    //   console.error(
    //     "Error fetching chat:",
    //     error.response?.data?.message || error.message,
    //   );
    // } 
    catch (error) {
      const status = error?.response?.status;
      const alterMsg = {
        message_id: "",
        msg: "Something went wrong. Please try again or refresh the page",
        rid: "",
        ts: new Date().toISOString(),
        u: {
          _id: "bot_id",
          name: "bot",
          username: "bot",
        }
      };

      if (error?.code === "ERR_NETWORK" || error?.message === "Network Error" || error?.code === "ERR_BAD_RESPONSE") {
        console.log(`Received ${status} error. Fetching chat history...`);
        getAllAiMessages();
      }else{
        setMessages((prevMessages) => [...prevMessages, alterMsg]);
        store.dispatch(setIsBotTyping(false));
      }
    
      console.error(
        "Error fetching chat:",
        error?.response?.data?.message || error?.message
      );
    } finally {
      dispatch(setIsUserTyping(false));
      setIsAccountChanged(true)
    }
  };

  const getAllAiMessages = async (data) => {
    try {
      const response = await axiosInstance.get(
        `${CHAT_BASE_URL}/bot/history/${data?.rid || RoomId}`,
        // {
        //   headers: {
        //     "Content-Type": "application/json",
        //   },
        // },
      );
      setMessages(response?.data?.data?.messages);
      if (UserId && Authtoken && RoomId) {
        getAllMessage();
      }
    } catch (error) {
      console.error(
        "Error fetching messages:",
        error?.response?.data?.message || error?.message,
      );
    } finally {
      store.dispatch(setIsBotTyping(false));
    }
  };

  useEffect(() => {
    const container = chatContainerRef.current;
    if (!container) return;

    const handleScroll = () => {
      const atBottom =
        container.scrollHeight - container.scrollTop <=
        container.clientHeight + 50;
      setIsAtBottom(atBottom);
    };

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (
      (autoScroll && messages?.length > prevMessageCountRef.current) ||
      isBotTyping
    ) {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }
    prevMessageCountRef.current = messages.length;
  }, [messages, autoScroll, isBotTyping]);

  useEffect(() => {
    if (
      autoScroll &&
      rocketchatMessages?.length > prevRocketMessageCountRef.current
    ) {
      rocketMessagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }
    prevRocketMessageCountRef.current = rocketchatMessages?.length;
  }, [rocketchatMessages, autoScroll]);

  useEffect(() => {
    if (
      autoScroll &&
      supportChat?.length > prevSupportMessageCountRef.current
    ) {
      supportMessagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }
    prevSupportMessageCountRef.current = supportChat?.length;
  }, [supportChat, autoScroll]);
  useEffect(() => {
    if (open || chatVisible) {
      setTimeout(() => {
        rocketMessagesEndRef?.current?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [open, chatVisible]);
  useEffect(() => {
    if (open || chatVisible) {
      setTimeout(() => {
        supportMessagesEndRef?.current?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [open, chatVisible]);

  const getChat = async (inp) => {
    const payload = {
      token: Authtoken,
      text: inp,
    };
    try {
      const response = await axios.post(
        `${CHAT_BASE_URL}/room/${RoomId}/send-message`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      dispatch(setIsUserTyping(false));
      // dispatch(setIsBotTyping(true));
      getAllMessage();
    } catch (error) {
      console.error(
        "Error fetching chat:",
        error.response?.data?.message || error.message,
      );
    } finally {
      dispatch(setIsUserTyping(false));
    }
  };

  const isValidUSPhone = (phone) => {
    return /^(\+1\s?)?((\(\d{3}\)|\d{3})[-.\s]?\d{3}[-.\s]?\d{4}|(\(\d{3}\)|\d{3})[-.\s]?\d{4})$/.test(
      phone.trim(),
    );
  };

  const isValidInput = () => {
    const value = inputValue?.trim();
    const inputType = supportSession?.input_type?.toLowerCase();

    if (!value) return false;

    if (["tel"].includes(inputType)) {
      return isValidUSPhone(value);
    }

    if (["email"].includes(inputType)) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }
    if (["date"].includes(inputType)) {
      return (
        /^\d{4}-\d{2}-\d{2}$/.test(value) ||
        /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}$/.test(value)
      );
    }
    if (["number"].includes(inputType)) {
      return /^-?\d+(\.\d+)?$/.test(value);
    }
    if (["text"].includes(inputType)) {
      if (value.length === 1 && /^\d$/.test(value)) {
        return false;
      }
      return true;
    }

    return true;
  };
  useEffect(() => {
    if (!UserId || !Authtoken || !RoomId || open === false) return;
    const interval = setInterval(() => {
      getAllMessage();
    }, 20000);
    return () => clearInterval(interval); // cleanup on unmount
  }, [UserId, Authtoken, RoomId, open, ChatRoomID]);

  const getSupportAiChat = async (
    answer,
    fieldKey = "",
    rid = "",
    supplier_id = "",
    flag,
  ) => {
    const payload = {
      account_id: baseAcctId
        ? baseAcctId
        : SelectedPharmacy?.length > 0
          ? SelectedPharmacy[SelectedPharmacy.length - 1]
          : null,
      supplier_id: supplierId || supplier_id || "46",
      rid: rid || "",
      field_key: fieldKey || "",
      answer: answer ?? "",
    };
    store.dispatch(setIsBotTyping(true));
    try {
      const response = await axios.post(`${CHAT_BASE_URL}/ai/account-fill`, payload);

      const data = response?.data?.data;
      setSupportSession({
        rid: data?.rid,
        field_key: data?.field_key,
        supplier_id: data?.supplier_id,
        input_type: data?.input_type,
      });

      if (flag === true) {
        setSupportChat((prev) => [
          ...prev,
          {
            type: "question",
            message: "File Uploaded SuccessFully.",
            ts: new Date(),
            input_type: "text",
            options: [],
            field_key: "",
          },
        ]);
      }

      if (data?.question) {
        setSupportChat((prev) => [
          ...prev,
          {
            type: "question",
            message: data?.question,
            ts: new Date(),
            input_type: data?.input_type,
            options: data?.options,
            field_key: data?.field_key,
          },
        ]);
      }
      if (data?.session_status === "complete") {
        setSupportChat((prev) => [
          ...prev,
          {
            type: "question",
            message: data?.message,
            ts: new Date(),
            input_type: data?.input_type,
            options: data?.options,
            field_key: data?.field_key,
          },
        ]);
      }
    } catch (error) {
      console.log(error, "Support AI Error");
    } finally {
      store.dispatch(setIsBotTyping(false));
      setIsAttachImage(false);
      setInputValueCheck(null);
    }
  };

  // const handleSendSupportAnswer = async () => {
  //   if (!inputValue.trim()) return;
  //   // Push user answer
  //   setSupportChat((prev) => [
  //     ...prev,
  //     {
  //       type: "answer",
  //       message: inputValue,
  //       ts: new Date(),
  //       input_type: "user_msg",
  //       options:[]
  //     },
  //   ]);

  //   const currentAnswer = inputValue;

  //   setInputValue("");

  //   // Call next question API
  //   await getSupportAiChat(
  //     currentAnswer,
  //     supportSession?.field_key,
  //     supportSession?.rid,
  //     supportSession?.supplier_id
  //   );
  // };

  useEffect(() => {
    if (!open) return;
    if (RoomId && !isSupport && !isAccountChanged && !UserId) {
      handleSend("chatsupport2", true);
    } else if(RoomId && !isSupport){
      getAllAiMessages();
    }
    else if (!isSupport) {
      handleSend("chatsupport", true);
    } else if (isSupport && supportChat?.length <= 1) {
      getSupportAiChat("agent_onboarding", "agent_onboarding");
    }
  }, [open]);

  // useChatSocket(
  //   RoomId, Authtoken
  // );

  useEffect(() => {
    if (open || chatVisible) {
      setTimeout(() => {
        messagesEndRef?.current?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [open, chatVisible]);

  // const handleAttach = () => {
  //   const input = document.createElement("input");
  //   input.type = "file";

  //   input.onchange = (e) => {
  //     const file = e.target.files[0];
  //     if (!file) return;

  //     const isImage = file.type.startsWith("image/");
  //     if (!isImage) {
  //       return;
  //     }
  //     setIsAttachImage(true);
  //     const reader = new FileReader();
  //     reader.onload = () => {
  //       setAttachedImage({
  //         fileName: file.name,
  //         previewUrl: reader.result,
  //         isImage,
  //       });
  //     };
  //     reader.readAsDataURL(file);
  //   };

  //   input.click();
  // };

  const closePreview = () => {
    setIsAttachImage(false);
  };

  const formatChatDate = (isoString) => {
    const date = new Date(isoString);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const isSameDay = (d1, d2) =>
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate();

    if (isSameDay(date, today)) return "Today";
    if (isSameDay(date, yesterday)) return "Yesterday";

    return date.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  // useEffect(()=>{
  //   setSupportChat([]);
  //   setOpen(false);
  // },[SelectedPharmacy])
  const handleSendSupportAnswer = async () => {
    const value =
      supportSession?.input_type === "multi_select"
        ? selectedOptions.join(", ")
        : inputValue;

    if (!value.trim()) return;

    setSupportChat((prev) => [
      ...prev,
      {
        type: "answer",
        message: value,
        ts: new Date(),
        input_type: "user_msg",
        options: [],
        field_key: "",
      },
    ]);

    setInputValue("");
    setSelectedOptions([]);

    await getSupportAiChat(
      value,
      supportSession?.field_key,
      supportSession?.rid,
      supportSession?.supplier_id,
    );
  };

   const accountMap = React.useMemo(() => {
      const map = {};
      allAcounts?.forEach((acc) => {
        map[acc.acct_id] = acc.name;
      });
      return map;
    }, [allAcounts]);
  
  return (
    <>
      <Modal
        isOpen={open}
        onRequestClose={() => setOpen(false)}
        className="chat-modal w-[88%] md:w-[32%] outline-none"
        overlayClassName="chat-overlay"
        ariaHideApp={false}
      >
        <div className="chat-container">
          <>
            <div className="chat-header">
              <div className="flex justify-between w-full">
                <div className="w-[62%] flex justify-end">
                  <img
                    src={AAPALOGO}
                    alt="logo"
                    className="w-28 h-24 object-contain p-0 m-0"
                  />
                </div>

                <div>
                  <MinusOutlined
                    onClick={() => {
                      setOpen(false);
                      dispatch(setIsBotTyping(false));
                    }}
                    className="dot-icon"
                    style={{
                      cursor: "pointer",
                      color: "#fff",
                      fontSize: "20px",
                    }}
                  />
                  <MoreOutlined
                    disabled
                    className="dot-icon"
                    style={{
                      cursor: "not-allowed",
                      color: "#fff",
                      fontSize: "20px",
                    }}
                  />
                  <LogoutOutlined
                    onClick={() => {
                      if (isSupport) {
                        setSupportChat([
                          {
                            type: "question",
                            message:
                              "Hi there! I'm Claira, the AdvantEdge Intelligence Assistant. I'm here to help you today. To better assist you, I'll need some information from your side. Please provide the requested details, and I'll guide you through the process.",
                            ts: new Date(),
                            input_type: "greeting_msg",
                            options: [],
                            field_key: "",
                          },
                        ]);
                        setOpen(false);
                      } else {
                        handleClose();
                      }
                    }}
                    style={{
                      cursor: "pointer",
                      color: "#fff",
                      fontSize: "20px",
                    }}
                  />
                </div>
              </div>
              {
                !isSupport && (
              <div className="text-white flex w-[100%] items-center justify-end" style={{marginTop:"-10px"}}>
               <StaticAccounts
              selectedAccounts={SelectedPharmacy}
              accountMap={accountMap}
            />
              </div>
                )
              }
            </div>
            {isSupport ? (
              isImageAttach ? (
                <div className="flex flex-1 justify-center items-center">
                  <Spin size="large" className="text-blue-900 " />
                </div>
              ) : (
                // <div className="image-preview-bar">
                //   <button className="close-btn" onClick={closePreview}>
                //     <CloseOutlined style={{ fontSize: 16, color: "#fff" }} />
                //   </button>
                //   <div className="preview-wrapper">
                //     <img
                //       src={attchedImage?.previewUrl}
                //       alt="preview"
                //       className="preview-image"
                //     />
                //   </div>

                //   <button className="send-btn2">
                //     <SendOutlined style={{ fontSize: 20, color: "#fff" }} />
                //   </button>
                // </div>
                <>
                  <div
                    ref={chatContainerRef}
                    className="chat-body chat-scroll-container"
                    style={{
                      flex: 1,
                      overflowY: "auto",
                      paddingTop: "16px",
                      display: "flex",
                      flexDirection: "column",
                      // gap: "12px",
                    }}
                  >
                    <div className="flex flex-col gap-3 py-4 h-[500px] overflow-y-auto">
                      {supportChat?.map((chat, index) => {
                        const isUser = chat?.type === "answer";
                        const AvatarURL = isUser ? profilePic : clairaLogoSvg;

                        return (
                          <>
                            <div
                              key={index}
                              className={`flex gap-2 mb-4 ${
                                isUser
                                  ? "justify-end"
                                  : "justify-start items-start"
                              }`}
                            >
                              {/* Left Avatar */}
                              {!isUser && (
                                <Avatar
                                  src={
                                    <img
                                      src={AvatarURL}
                                      alt="avatar"
                                      className="w-full h-full object-cover"
                                    />
                                  }
                                  size={60}
                                  className="mt-1 flex-shrink-0"
                                  style={{
                                    objectFit: "contain",
                                  }}
                                />
                              )}

                              <div
                                className={`max-w-[65%] px-4 py-3 rounded-2xl text-sm shadow-md ${
                                  isUser
                                    ? "bg-[#000437] text-white rounded-br-sm"
                                    : "bg-white text-[#222] rounded-bl-sm"
                                }`}
                              >
                                {chat?.message}

                                {chat?.input_type === "multi_select" &&
                                  chat?.options?.length > 0 && (
                                    <div className="flex flex-wrap gap-2 ">
                                      {chat?.options
                                        ?.filter(
                                          (option) =>
                                            typeof option === "string",
                                        )
                                        ?.map((option) => (
                                          <label
                                            key={option}
                                            className={`flex items-center gap-2 px-3 py-2 rounded-xl border cursor-pointer transition-all
          ${
            selectedOptions?.includes(option)
              ? "border-[#000437]"
              : "bg-white text-gray-700 border-gray-300"
          }`}
                                          >
                                            <input
                                              type="checkbox"
                                              checked={selectedOptions?.includes(
                                                option,
                                              )}
                                              onChange={() =>
                                                handleMultiSelect(option)
                                              }
                                              className="accent-[#000437]"
                                            />
                                            <span>{option}</span>
                                          </label>
                                        ))}
                                    </div>
                                  )}
                                {chat?.input_type === "checkbox" && (
                                  <div className="mt-3 flex gap-6">
                                    <label className="flex items-center gap-2 cursor-pointer">
                                      <input
                                        type="radio"
                                        name={`checkboxOption-${chat.field_key}`}
                                        checked={
                                          checkboxValues[chat.field_key] ===
                                          true
                                        }
                                        onChange={() => {
                                          setCheckboxValues((prev) => ({
                                            ...prev,
                                            [chat.field_key]: true,
                                          }));

                                          getSupportAiChat(
                                            true,
                                            chat.field_key,
                                            chat.rid,
                                            chat.supplier_id,
                                          );
                                        }}
                                      />
                                      <span className="text-black">Yes</span>
                                    </label>

                                    <label className="flex items-center gap-2 cursor-pointer">
                                      <input
                                        type="radio"
                                        name={`checkboxOption-${chat?.field_key}`}
                                        checked={
                                          checkboxValues[chat?.field_key] ===
                                          false
                                        }
                                        onChange={() => {
                                          setCheckboxValues((prev) => ({
                                            ...prev,
                                            [chat.field_key]: false,
                                          }));

                                          getSupportAiChat(
                                            false,
                                            chat.field_key,
                                            chat.rid,
                                            chat.supplier_id,
                                          );
                                        }}
                                      />
                                      <span className="text-black">No</span>
                                    </label>
                                  </div>
                                )}
                                <div
                                  className={`text-[10px] mt-1 text-right ${
                                    isUser ? "text-gray-300" : "text-gray-500"
                                  }`}
                                >
                                  {new Date(chat?.ts).toLocaleTimeString([], {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  })}
                                </div>
                              </div>

                              {isUser && (
                                <Avatar
                                  src={
                                    <img
                                      src={AvatarURL}
                                      alt="avatar"
                                      className="w-full h-full object-cover"
                                    />
                                  }
                                  size={48}
                                  className="mt-1 flex-shrink-0"
                                />
                              )}
                            </div>
                            {chat?.input_type === "file_upload" && (
                              <div
                                style={{
                                  border: "2px dashed #7ec3ff",
                                  borderRadius: 10,
                                  padding: "10px 20px",
                                  textAlign: "center",
                                  background: "#fff",
                                  width: "65%",
                                  margin: "0 auto",
                                  marginLeft: "70px",
                                }}
                              >
                                <div
                                  style={{
                                    fontSize: 40,
                                    color: "#1890ff",
                                    marginBottom: 12,
                                  }}
                                >
                                  <UploadOutlined />
                                </div>
                                <div className="flex justify-center align-center text-[#333] my-3">
                                  Please Upload the File
                                </div>

                                <label
                                  htmlFor="file-upload"
                                  style={{
                                    display: "inline-block",
                                    background: "#1890ff",
                                    color: "#fff",
                                    padding: "8px 35px",
                                    borderRadius: 20,
                                    cursor: "pointer",
                                    fontWeight: 500,
                                    marginBottom: 10,
                                  }}
                                >
                                  Browse
                                </label>

                                <input
                                  id="file-upload"
                                  type="file"
                                  accept=".csv,.pdf,.doc,.docx,.jpg,.jpeg,.png"
                                  style={{ display: "none" }}
                                  onChange={handleFileChange}
                                />

                                {/* <div
        style={{
          color: "#999",
          fontSize: 14,
          marginBottom: 12,
        }}
      >
        drop a file here
      </div> */}

                                <div
                                  style={{
                                    fontSize: 13,
                                    color: "#555",
                                  }}
                                >
                                  <span style={{ color: "red" }}>*</span> File
                                  supported .csv, .pdf, .doc, .docx, jpg, png
                                </div>

                                {/* {file && (
        <div
          style={{
            marginTop: 15,
            padding: 10,
            background: "#f5f5f5",
            borderRadius: 6,
            wordBreak: "break-word",
          }}
        >
          Selected: <strong>{file.name}</strong>
        </div>
      )} */}
                              </div>
                            )}
                          </>
                        );
                      })}
                      <div ref={supportMessagesEndRef} />
                    </div>
                  </div>
                  {isBotTyping ? (
                    <div
                      className="bot-typing-indicator"
                      style={{
                        padding: "12px 20px",
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                      }}
                    >
                      <span style={{ fontSize: 14, color: "#888" }}>
                        Bot is typing
                      </span>
                      <span
                        className="typing-dots"
                        style={{ display: "flex", gap: 4 }}
                      >
                        <span
                          className="dot"
                          style={{
                            width: 6,
                            height: 6,
                            borderRadius: "50%",
                            background: "#888",
                            animation: "bounce 1s infinite",
                          }}
                        />
                        <span
                          className="dot"
                          style={{
                            width: 6,
                            height: 6,
                            borderRadius: "50%",
                            background: "#888",
                            animation: "bounce 1s infinite 0.2s",
                          }}
                        />
                        <span
                          className="dot"
                          style={{
                            width: 6,
                            height: 6,
                            borderRadius: "50%",
                            background: "#888",
                            animation: "bounce 1s infinite 0.4s",
                          }}
                        />
                      </span>
                    </div>
                  ) : (
                    <>
                      {/* {selectedOptions.length > 0 && (
      <div className="px-3 py-2 border-t bg-gray-50 flex flex-wrap gap-2">
        {selectedOptions.map((item) => (
          <span
            key={item}
            className="bg-[#000437] text-white text-xs px-3 py-1 rounded-full"
          >
            {item}
          </span>
        ))}
      </div>
    )} */}

                      <div className="chat-input">
                        {/* <button className="icon-btn" disabled={isBotTyping} onClick={handleAttach}>
                      <PaperClipOutlined style={{ fontSize: 20 }} />
                    </button> */}
                        <input
                          type="text"
                          value={inputValue}
                          onChange={(e) => setInputValue(e.target.value)}
                          placeholder="Type your answer..."
                          className="flex-1 border rounded-full px-4 py-2 outline-none"
                          onKeyDown={(e) => {
                            if (e.key === "Enter" && isValidInput()) {
                              handleSendSupportAnswer();
                            }
                          }}
                        />
                        <button
                          disabled={isBotTyping || !isValidInput()}
                          className="send-btn"
                          onClick={handleSendSupportAnswer}
                        >
                          <SendOutlined
                            style={{ fontSize: 20, color: "white" }}
                          />
                        </button>
                      </div>
                    </>
                  )}
                </>
              )
            ) : isImageAttach ? (
              <div className="image-preview-bar">
                <button className="close-btn" onClick={closePreview}>
                  <CloseOutlined style={{ fontSize: 16, color: "#fff" }} />
                </button>
                <div className="preview-wrapper">
                  <img
                    src={attchedImage?.previewUrl}
                    alt="preview"
                    className="preview-image"
                  />
                </div>

                <button className="send-btn2">
                  <SendOutlined style={{ fontSize: 20, color: "#fff" }} />
                </button>
              </div>
            ) : (
              <>
                <div
                  ref={chatContainerRef}
                  className="chat-body chat-scroll-container"
                  style={{
                    flex: 1,
                    overflowY: "auto",
                    paddingTop: "16px",
                    display: "flex",
                    flexDirection: "column",
                    // gap: "12px",
                  }}
                >
                  {[...messages]
                    ?.sort((a, b) => new Date(a?.ts) - new Date(b?.ts))
                    .filter((m) => m?.msg && m.msg.trim() !== "")
                    ?.map((msg, index, arr) => {
                      const isUser =
                        msg?.u?._id === UserId ||
                        msg?.u?.name === "guest" ||
                        userInfo?.user?.email === msg?.u?.username;
                      const sender = isUser ? "user" : "bot";
                      const AvatarURL = isUser ? profilePic : clairaLogoSvg;
                      const prevMsg = arr[index - 1];
                      const prevSender =
                        prevMsg?.u?._id === UserId ||
                        prevMsg?.u?.name === "guest" ||
                        userInfo?.user?.email === prevMsg?.u?.username
                          ? "user"
                          : "bot";
                      const text = msg?.msg || "";
                      const time = new Date(msg?.ts).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      });
                      let fullMessage = text.trim();
                      fullMessage = fullMessage.replace(/```/g, "");

                      fullMessage = fullMessage.replace(
                        /(https?:\/\/[^\s]+)/g,
                        (url) => `[${url}](${url})`,
                      );
                      fullMessage = fullMessage.replace(/<br\s*\/?>/gi, "\n");

                      const showAvatar = index === 0 || sender !== prevSender;
                      const msgKey =
                        msg?._id ||
                        msg?.id ||
                        `${msg?.ts}-${(msg?.msg || "").slice(0, 20)}`;
                      const selectedIndexForThisMsg = choiceSelections[msgKey];
                      const isLocked = selectedIndexForThisMsg !== undefined;
                      const currentDate = new Date(msg?.ts);
                      const prevMessage = arr[index - 1];
                      const prevDate = prevMessage
                        ? new Date(prevMessage.ts)
                        : null;

                      const shouldShowDate =
                        index === 0 ||
                        currentDate.toDateString() !== prevDate?.toDateString();
                      return (
                        <>
                          {shouldShowDate && (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginTop: "20px",
                                gap: "10px",
                              }}
                            >
                              <div
                                style={{
                                  flex: 1,
                                  height: 1,
                                  background: "#dcdcdc",
                                }}
                              ></div>
                              <span
                                style={{
                                  fontSize: 12,
                                  color: "#666",
                                  background: "#f5f5f5",
                                  padding: "4px 10px",
                                  borderRadius: 20,
                                }}
                              >
                                {formatChatDate(msg?.ts)}
                              </span>

                              <div
                                style={{
                                  flex: 1,
                                  height: 1,
                                  background: "#dcdcdc",
                                }}
                              ></div>
                            </div>
                          )}

                          <div
                            style={{
                              background: sender == "user" ? null : null,
                              marginBottom: sender == "user" ? "5px" : "5px",
                              // paddingBottom: 10,
                              // borderRadius:20,
                              borderTopLeftRadius:
                                index > 0 && sender !== prevSender ? 20 : 0,
                              borderTopRightRadius:
                                index > 0 && sender !== prevSender ? 20 : 0,
                              borderBottomRightRadius:
                                index > 0 && sender !== prevSender ? 20 : 0,
                              borderBottomLeftRadius:
                                index > 0 && sender !== prevSender ? 20 : 0,
                              width: sender == "user" ? "100%" : "76%",
                            }}
                          >
                            {fullMessage && (
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  flexDirection:
                                    sender === "user" ? "row-reverse" : "row",
                                  alignItems: "flex-start",
                                  gap: 8,
                                  marginTop:
                                    index > 0 && sender !== prevSender
                                      ? 20
                                      : 10,
                                  marginLeft: 3,
                                }}
                              >
                                {showAvatar ? (
                                  <div
                                    style={{
                                      width: sender == "user" ? 45 : 55,
                                      height: sender == "user" ? 45 : 55,
                                      flexShrink: 0,
                                    }}
                                  >
                                    <Avatar
                                      src={AvatarURL}
                                      alt={sender}
                                      size={sender == "user" ? 45 : 55}
                                      style={{
                                        objectFit: "contain",
                                        flexShrink: 0,
                                        width: "100%",
                                        height: "100%",
                                      }}
                                      // size={"large"}
                                    />
                                  </div>
                                ) : (
                                  <div style={{ width: 55 }} />
                                )}
                                <div
                                  style={{
                                    background:
                                      sender === "user" ? "#000437" : "#fff",
                                    padding: "8px 12px",
                                    borderTopLeftRadius: 25,
                                    borderTopRightRadius: 25,
                                    borderBottomRightRadius:
                                      sender === "user" ? 0 : 25,
                                    borderBottomLeftRadius:
                                      sender === "user" ? 25 : 0,
                                    // maxWidth: "65%",
                                    maxWidth: sender === "user" ? "65%" : "84%",
                                    // boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                                  }}
                                >
                                  <div
                                    style={{
                                      color:
                                        sender === "user" ? "#fff" : "#333",
                                      fontSize: 14,
                                      fontFamily: "Arial, sans-serif",
                                      direction: "ltr",
                                      textAlign: "left",
                                    }}
                                  >
                                    <ReactMarkdown
                                      children={fullMessage}
                                      remarkPlugins={[remarkGfm]}
                                      rehypePlugins={[
                                        rehypeRaw,
                                        rehypeSanitize,
                                      ]}
                                      components={{
                                        p: ({ node, ...props }) => (
                                          <p
                                            style={{
                                              margin: "8px 0",
                                              lineHeight: "1.6",
                                            }}
                                            {...props}
                                          />
                                        ),
                                        strong: ({ node, ...props }) => (
                                          <strong
                                            style={{ fontWeight: "bold" }}
                                            {...props}
                                          />
                                        ),
                                        em: ({ node, ...props }) => (
                                          <em
                                            style={{ fontStyle: "italic" }}
                                            {...props}
                                          />
                                        ),
                                        ul: ({ node, ...props }) => (
                                          <ul
                                            style={{
                                              paddingLeft: 20,
                                              margin: "8px 8px",
                                              listStyleType: "disc",
                                            }}
                                            {...props}
                                          />
                                        ),
                                        ol: ({ node, ...props }) => (
                                          <ol
                                            style={{
                                              paddingLeft: 20,
                                              margin: "8px 8px",
                                              listStyleType: "decimal",
                                            }}
                                            {...props}
                                          />
                                        ),
                                        li: ({ node, ...props }) => (
                                          <li
                                            style={{ marginBottom: 4 }}
                                            {...props}
                                          />
                                        ),
                                        a: ({ node, ...props }) => (
                                          <a
                                            style={{
                                              color:
                                                sender === "user"
                                                  ? "#aadfff"
                                                  : "#007bff",
                                              textDecoration: "underline",
                                              wordBreak: "break-word",
                                            }}
                                            {...props}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          />
                                        ),
                                        code: ({ node, ...props }) => (
                                          <code
                                            style={{
                                              background: "#f4f4f4",
                                              padding: "2px 4px",
                                              borderRadius: 4,
                                            }}
                                            {...props}
                                          />
                                        ),
                                        table: ({ node, ...props }) => (
                                          <div
                                            style={{
                                              overflowX: "auto",
                                              margin: "12px 0",
                                              width: "100%",
                                            }}
                                          >
                                            <table
                                              style={{
                                                borderCollapse: "collapse",
                                                width: "100%",
                                                minWidth: "400px",
                                                fontSize: "14px",
                                                fontFamily: "inherit",
                                              }}
                                              {...props}
                                            />
                                          </div>
                                        ),

                                        thead: ({ node, ...props }) => (
                                          <thead
                                            style={{
                                              backgroundColor:
                                                sender === "user"
                                                  ? "#1a6fa3"
                                                  : "#f0f4f8",
                                              color:
                                                sender === "user"
                                                  ? "#ffffff"
                                                  : "#222222",
                                            }}
                                            {...props}
                                          />
                                        ),

                                        tbody: ({ node, ...props }) => (
                                          <tbody {...props} />
                                        ),

                                        // tr: ({ node, ...props }) => (
                                        //   <tr
                                        //     style={{
                                        //       borderBottom: "1px solid #e0e0e0",
                                        //       backgroundColor: "transparent",
                                        //     }}
                                        //     onMouseEnter={(e) =>
                                        //       (e.currentTarget.style.backgroundColor =
                                        //         "#f9f9f9")
                                        //     }
                                        //     onMouseLeave={(e) =>
                                        //       (e.currentTarget.style.backgroundColor =
                                        //         "transparent")
                                        //     }
                                        //     {...props}
                                        //   />
                                        // ),

                                        tr: ({ node, children, ...props }) => {
                                          const hiddenMetrics = [
                                            "Rebateable Brand",
                                            "Rebateable Generic",
                                            "Rebate Brand ($)",
                                            "Rebate Generic ($)",
                                            "Rebate Total ($)",
                                          ];
                                        
                                          // Get the first cell (Metric) value from this row
                                          const metric =
                                            node?.children?.[0]?.children?.[0]?.value?.trim() || "";
                                        
                                          // Hide the complete row if metric matches
                                          if (hiddenMetrics.includes(metric)) {
                                            return null;
                                          }
                                        
                                          return (
                                            <tr
                                              style={{
                                                borderBottom: "1px solid #e0e0e0",
                                                backgroundColor: "transparent",
                                              }}
                                              onMouseEnter={(e) =>
                                                (e.currentTarget.style.backgroundColor = "#f9f9f9")
                                              }
                                              onMouseLeave={(e) =>
                                                (e.currentTarget.style.backgroundColor = "transparent")
                                              }
                                              {...props}
                                            >
                                              {children}
                                            </tr>
                                          );
                                        },
                                        th: ({ node, ...props }) => (
                                          <th
                                            style={{
                                              padding: "8px 12px",
                                              textAlign: "left",
                                              fontWeight: "600",
                                              fontSize: "12px",
                                              whiteSpace: "nowrap",
                                              borderBottom: "2px solid #cbd5e1",
                                            }}
                                            {...props}
                                          />
                                        ),

                                        // td: ({ node, ...props }) => (
                                        //   <td
                                        //     style={{
                                        //       padding: "7px 12px",
                                        //       textAlign: "left",
                                        //       whiteSpace: "nowrap",
                                        //       color:
                                        //         sender === "user"
                                        //           ? "#ffffff"
                                        //           : "#222",
                                        //       borderBottom: "1px solid #e5e7eb",
                                        //     }}
                                        //     {...props}
                                        //   />
                                        // ),

                                        td: ({ node, children, ...props }) => {
                                          const row =
                                            node?.parent?.children || [];

                                          // First column value (Metric)
                                          const metric =
                                            row?.[0]?.children?.[0]?.value?.trim() ||
                                            "";

                                          let value = children;

                                          // Don't format first column
                                          const isMetricColumn =
                                            node === row?.[0];

                                          if (!isMetricColumn) {
                                            const text = String(children);

                                            if (
                                              text !== "-" &&
                                              !isNaN(Number(text))
                                            ) {
                                              if (
                                                [
                                                  "Total Rx",
                                                  "Generic Rx",
                                                  "Brand Rx",
                                                ].includes(metric)
                                              ) {
                                                value = `$${Number(
                                                  text,
                                                ).toLocaleString(undefined, {
                                                  minimumFractionDigits: 2,
                                                  maximumFractionDigits: 2,
                                                })}`;
                                              }

                                              if (metric === "GCR %") {
                                                value = `${Number(text).toFixed(2)}%`;
                                              }
                                            }
                                          }

                                          return (
                                            <td
                                              style={{
                                                padding: "7px 12px",
                                                textAlign: "left",
                                                whiteSpace: "nowrap",
                                                color:
                                                  sender === "user"
                                                    ? "#ffffff"
                                                    : "#222",
                                                borderBottom:
                                                  "1px solid #e5e7eb",
                                              }}
                                              {...props}
                                            >
                                              {value}
                                            </td>
                                          );
                                        },
                                      }}
                                    />
                                  </div>
                                  {
                                    <div
                                      style={{
                                        fontSize: 10,
                                        textAlign: "right",
                                        color:
                                          sender === "user"
                                            ? "#d5dbd6"
                                            : "#888",
                                      }}
                                    >
                                      {time}
                                    </div>
                                  }
                                </div>
                              </div>
                            )}
                          </div>
                        </>
                      );
                    })}
                  {[...rocketchatMessages]
                    ?.sort((a, b) => new Date(a?.ts) - new Date(b?.ts))
                    .filter((m) => m?.msg && m.msg.trim() !== "")
                    ?.map((msg, index, arr) => {
                      const isUser =
                        msg?.u?._id === UserId ||
                        msg?.u?.name === "guest" ||
                        userInfo?.user?.email === msg?.u?.username;
                      const sender = isUser ? "user" : "bot";
                      const AvatarURL = isUser ? profilePic : clairaLogoSvg;
                      const prevMsg = arr[index - 1];
                      const prevSender =
                        prevMsg?.u?._id === UserId ||
                        prevMsg?.u?.name === "guest" ||
                        userInfo?.user?.email === prevMsg?.u?.username
                          ? "user"
                          : "bot";
                      const text = msg?.msg || "";
                      const time = new Date(msg?.ts).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      });
                      let fullMessage = text.trim();
                      fullMessage = fullMessage.replace(/```/g, "");

                      fullMessage = fullMessage.replace(
                        /(https?:\/\/[^\s]+)/g,
                        (url) => `[${url}](${url})`,
                      );
                      fullMessage = fullMessage.replace(/<br\s*\/?>/gi, "\n");
                      const displayMessage =
                        fullMessage?.trim().toLowerCase() === "connected"
                          ? `Hi there! This is ${msg?.u?.name}. I'm here to help you.?`
                          : fullMessage;

                      const showAvatar = index === 0 || sender !== prevSender;
                      const msgKey =
                        msg?._id ||
                        msg?.id ||
                        `${msg?.ts}-${(msg?.msg || "").slice(0, 20)}`;
                      const selectedIndexForThisMsg = choiceSelections[msgKey];
                      const isLocked = selectedIndexForThisMsg !== undefined;
                      const currentDate = new Date(msg?.ts);
                      const prevMessage = arr[index - 1];
                      const prevDate = prevMessage
                        ? new Date(prevMessage.ts)
                        : null;

                      const shouldShowDate =
                        index === 0 ||
                        currentDate.toDateString() !== prevDate?.toDateString();
                      return (
                        <>
                          {shouldShowDate && (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginTop: "20px",
                                gap: "10px",
                              }}
                            >
                              <div
                                style={{
                                  flex: 1,
                                  height: 1,
                                  background: "#dcdcdc",
                                }}
                              ></div>
                              <span
                                style={{
                                  fontSize: 12,
                                  color: "#666",
                                  background: "#f5f5f5",
                                  padding: "4px 10px",
                                  borderRadius: 20,
                                }}
                              >
                                {formatChatDate(msg?.ts)}
                              </span>

                              <div
                                style={{
                                  flex: 1,
                                  height: 1,
                                  background: "#dcdcdc",
                                }}
                              ></div>
                            </div>
                          )}

                          <div
                            style={{
                              background: sender == "user" ? null : null,
                              marginBottom: sender == "user" ? "5px" : "5px",
                              // paddingBottom: 10,
                              // borderRadius:20,
                              borderTopLeftRadius:
                                index > 0 && sender !== prevSender ? 20 : 0,
                              borderTopRightRadius:
                                index > 0 && sender !== prevSender ? 20 : 0,
                              borderBottomRightRadius:
                                index > 0 && sender !== prevSender ? 20 : 0,
                              borderBottomLeftRadius:
                                index > 0 && sender !== prevSender ? 20 : 0,
                              width: sender == "user" ? "100%" : "76%",
                            }}
                          >
                            {displayMessage && (
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  flexDirection:
                                    sender === "user" ? "row-reverse" : "row",
                                  alignItems: "flex-start",
                                  gap: 8,
                                  marginTop:
                                    index > 0 && sender !== prevSender
                                      ? 20
                                      : 10,
                                  marginLeft: 3,
                                }}
                              >
                                {showAvatar ? (
                                  <div
                                    style={{
                                      width: sender == "user" ? 45 : 55,
                                      height: sender == "user" ? 45 : 55,
                                      flexShrink: 0,
                                    }}
                                  >
                                    <Avatar
                                      src={AvatarURL}
                                      alt={sender}
                                      size={sender == "user" ? 45 : 55}
                                      style={{
                                        objectFit: "contain",
                                        flexShrink: 0,
                                        width: "100%",
                                        height: "100%",
                                      }}
                                      // size={"large"}
                                    />
                                  </div>
                                ) : (
                                  <div style={{ width: 55 }} />
                                )}
                                <div
                                  style={{
                                    background:
                                      sender === "user" ? "#000437" : "#fff",
                                    padding: "8px 12px",
                                    borderTopLeftRadius: 25,
                                    borderTopRightRadius: 25,
                                    borderBottomRightRadius:
                                      sender === "user" ? 0 : 25,
                                    borderBottomLeftRadius:
                                      sender === "user" ? 25 : 0,
                                    // maxWidth: "65%",
                                    maxWidth: sender === "user" ? "65%" : "84%",
                                    // boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                                  }}
                                >
                                  <div
                                    style={{
                                      color:
                                        sender === "user" ? "#fff" : "#333",
                                      fontSize: 14,
                                      fontFamily: "Arial, sans-serif",
                                      direction: "ltr",
                                      textAlign: "left",
                                    }}
                                  >
                                    <ReactMarkdown
                                      children={displayMessage}
                                      remarkPlugins={[remarkGfm]}
                                      rehypePlugins={[
                                        rehypeRaw,
                                        rehypeSanitize,
                                      ]}
                                      components={{
                                        p: ({ node, ...props }) => (
                                          <p
                                            style={{
                                              margin: "8px 0",
                                              lineHeight: "1.6",
                                            }}
                                            {...props}
                                          />
                                        ),
                                        strong: ({ node, ...props }) => (
                                          <strong
                                            style={{ fontWeight: "bold" }}
                                            {...props}
                                          />
                                        ),
                                        em: ({ node, ...props }) => (
                                          <em
                                            style={{ fontStyle: "italic" }}
                                            {...props}
                                          />
                                        ),
                                        ul: ({ node, ...props }) => (
                                          <ul
                                            style={{
                                              paddingLeft: 20,
                                              margin: "8px 8px",
                                              listStyleType: "disc",
                                            }}
                                            {...props}
                                          />
                                        ),
                                        ol: ({ node, ...props }) => (
                                          <ol
                                            style={{
                                              paddingLeft: 20,
                                              margin: "8px 8px",
                                              listStyleType: "decimal",
                                            }}
                                            {...props}
                                          />
                                        ),
                                        li: ({ node, ...props }) => (
                                          <li
                                            style={{ marginBottom: 4 }}
                                            {...props}
                                          />
                                        ),
                                        a: ({ node, ...props }) => (
                                          <a
                                            style={{
                                              color:
                                                sender === "user"
                                                  ? "#aadfff"
                                                  : "#007bff",
                                              textDecoration: "underline",
                                              wordBreak: "break-word",
                                            }}
                                            {...props}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          />
                                        ),
                                        code: ({ node, ...props }) => (
                                          <code
                                            style={{
                                              background: "#f4f4f4",
                                              padding: "2px 4px",
                                              borderRadius: 4,
                                            }}
                                            {...props}
                                          />
                                        ),
                                        table: ({ node, ...props }) => (
                                          <div
                                            style={{
                                              overflowX: "auto",
                                              margin: "12px 0",
                                              width: "100%",
                                            }}
                                          >
                                            <table
                                              style={{
                                                borderCollapse: "collapse",
                                                width: "100%",
                                                minWidth: "400px",
                                                fontSize: "14px",
                                                fontFamily: "inherit",
                                              }}
                                              {...props}
                                            />
                                          </div>
                                        ),

                                        thead: ({ node, ...props }) => (
                                          <thead
                                            style={{
                                              backgroundColor:
                                                sender === "user"
                                                  ? "#1a6fa3"
                                                  : "#f0f4f8",
                                              color:
                                                sender === "user"
                                                  ? "#ffffff"
                                                  : "#222222",
                                            }}
                                            {...props}
                                          />
                                        ),

                                        tbody: ({ node, ...props }) => (
                                          <tbody {...props} />
                                        ),

                                        // tr: ({ node, ...props }) => (
                                        //   <tr
                                        //     style={{
                                        //       borderBottom: "1px solid #e0e0e0",
                                        //       backgroundColor: "transparent",
                                        //     }}
                                        //     onMouseEnter={(e) =>
                                        //       (e.currentTarget.style.backgroundColor =
                                        //         "#f9f9f9")
                                        //     }
                                        //     onMouseLeave={(e) =>
                                        //       (e.currentTarget.style.backgroundColor =
                                        //         "transparent")
                                        //     }
                                        //     {...props}
                                        //   />
                                        // ),
                                      
                                        tr: ({ node, children, ...props }) => {
                                          const hiddenMetrics = [
                                            "Rebateable Brand",
                                            "Rebateable Generic",
                                            "Rebate Brand ($)",
                                            "Rebate Generic ($)",
                                            "Rebate Total ($)",
                                          ];
                                        
                                          // Get the first cell (Metric) value from this row
                                          const metric =
                                            node?.children?.[0]?.children?.[0]?.value?.trim() || "";
                                        
                                          // Hide the complete row if metric matches
                                          if (hiddenMetrics.includes(metric)) {
                                            return null;
                                          }
                                        
                                          return (
                                            <tr
                                              style={{
                                                borderBottom: "1px solid #e0e0e0",
                                                backgroundColor: "transparent",
                                              }}
                                              onMouseEnter={(e) =>
                                                (e.currentTarget.style.backgroundColor = "#f9f9f9")
                                              }
                                              onMouseLeave={(e) =>
                                                (e.currentTarget.style.backgroundColor = "transparent")
                                              }
                                              {...props}
                                            >
                                              {children}
                                            </tr>
                                          );
                                        },

                                        th: ({ node, ...props }) => (
                                          <th
                                            style={{
                                              padding: "8px 12px",
                                              textAlign: "left",
                                              fontWeight: "600",
                                              fontSize: "12px",
                                              whiteSpace: "nowrap",
                                              borderBottom: "2px solid #cbd5e1",
                                            }}
                                            {...props}
                                          />
                                        ),

                                        td: ({ node, ...props }) => (
                                          <td
                                            style={{
                                              padding: "7px 12px",
                                              textAlign: "left",
                                              whiteSpace: "nowrap",
                                              color:
                                                sender === "user"
                                                  ? "#ffffff"
                                                  : "#222",
                                              borderBottom: "1px solid #e5e7eb",
                                            }}
                                            {...props}
                                          />
                                        ),
                                      }}
                                    />
                                  </div>
                                  {
                                    <div
                                      style={{
                                        fontSize: 10,
                                        textAlign: "right",
                                        color:
                                          sender === "user"
                                            ? "#d5dbd6"
                                            : "#888",
                                      }}
                                    >
                                      {time}
                                    </div>
                                  }
                                </div>
                              </div>
                            )}
                          </div>
                        </>
                      );
                    })}
                  {/* {isUserTyping && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row-reverse",
                          alignItems: "flex-start",
                          gap: 8,
                          marginRight: 10,
                          marginTop: 20,
                        }}
                      >
                        <Avatar src={profilePic} alt="user" size={"large"} />
                        <div
                          style={{
                            background: "#000437",
                            padding: "8px 12px",
                            borderTopLeftRadius: 25,
                            borderTopRightRadius: 25,
                            borderBottomRightRadius: 0,
                            borderBottomLeftRadius: 25,
                            maxWidth: "65%",
                            fontSize: 14,
                            fontFamily: "arial",
                            color: "#fff",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                          }}
                        >
                          <div>{inputValue || "Sending..."}</div>
                        </div>
                      </div>
                    )} */}
                  {talkToAgent && (
                    <div
                      style={{
                        background: "#fff",
                        marginLeft: 62,
                        marginTop: 10,
                        padding: "10px",
                        borderRadius: "8px",
                        width: "64%",
                        textAlign: "center",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                      }}
                    >
                      <p
                        style={{
                          marginBottom: "12px",
                          fontSize: "14px",
                          lineHeight: "1.6",
                        }}
                      >
                        Please confirm, do you want to connect to an agent ?
                      </p>

                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          style={{
                            height: "32px",
                            padding: "0 14px",
                            background: "#4b5563", // soft gray
                            color: "#fff",
                            border: "none",
                            borderRadius: "6px",
                            cursor: "pointer",
                            fontSize: "13px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            transition: "background 0.2s ease",
                          }}
                          onMouseEnter={(e) =>
                            (e.target.style.background = "#374151")
                          }
                          onMouseLeave={(e) =>
                            (e.target.style.background = "#4b5563")
                          }
                          onClick={() => handleChatLogin()}
                        >
                          Yes
                        </button>

                        <button
                          style={{
                            height: "32px",
                            padding: "0 14px",
                            background: "#e5e7eb", // light gray
                            color: "#111827",
                            border: "none",
                            borderRadius: "6px",
                            cursor: "pointer",
                            fontSize: "13px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            transition: "background 0.2s ease",
                          }}
                          onMouseEnter={(e) =>
                            (e.target.style.background = "#d1d5db")
                          }
                          onMouseLeave={(e) =>
                            (e.target.style.background = "#e5e7eb")
                          }
                          onClick={() => setTalkToAgent(false)}
                        >
                          No
                        </button>
                      </div>
                    </div>
                  )}

                  {/* {isBotTyping && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-start",
                      gap: 8,
                      marginLeft: 10,
                    }}
                  >
                    <Avatar src={bot} alt="bot" size={"large"} />
                    <div
                      style={{
                        background: "#fff",
                        padding: "8px 12px",
                        borderTopLeftRadius: 25,
                        borderTopRightRadius: 25,
                        borderBottomRightRadius: 25,
                        borderBottomLeftRadius: 0,
                        maxWidth: "65%",
                        fontSize: 14,
                        fontFamily: "arial",
                        color: "#333",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                      }}
                    >
                      <div>......</div>
                    </div>
                  </div>
                )} */}

                  <div ref={messagesEndRef} />
                  <div ref={rocketMessagesEndRef} />
                </div>
                {isBotTyping ? (
                  // <div
                  //   className="bot-typing-indicator"
                  //   style={{
                  //     padding: "12px 20px",
                  //     display: "flex",
                  //     alignItems: "center",
                  //     gap: 8,
                  //   }}
                  // >
                  //   <span style={{ fontSize: 14, color: "#888" }}>
                  //     Bot is typing
                  //   </span>
                  //   <span
                  //     className="typing-dots"
                  //     style={{ display: "flex", gap: 4 }}
                  //   >
                  //     <span
                  //       className="dot"
                  //       style={{
                  //         width: 6,
                  //         height: 6,
                  //         borderRadius: "50%",
                  //         background: "#888",
                  //         animation: "bounce 1s infinite",
                  //       }}
                  //     />
                  //     <span
                  //       className="dot"
                  //       style={{
                  //         width: 6,
                  //         height: 6,
                  //         borderRadius: "50%",
                  //         background: "#888",
                  //         animation: "bounce 1s infinite 0.2s",
                  //       }}
                  //     />
                  //     <span
                  //       className="dot"
                  //       style={{
                  //         width: 6,
                  //         height: 6,
                  //         borderRadius: "50%",
                  //         background: "#888",
                  //         animation: "bounce 1s infinite 0.4s",
                  //       }}
                  //     />
                  //   </span>
                  // </div>
                  <div
  className="bot-typing-indicator"
  style={{
    padding: "12px 20px",
    display: "flex",
    alignItems: "center",
    gap: 10,
  }}
>
  <span
    style={{
      fontSize: 15,
      color: "#6b7280",
      fontWeight: 500,
      transition: "opacity 0.3s ease",
    }}
  >
    {thinkingText}
  </span>

  <span
    className="typing-dots"
    style={{
      display: "flex",
      alignItems: "center",
      gap: 4,
    }}
  >
    <span
      className="dot"
      style={{
        width: 8,
        height: 8,
        borderRadius: "50%",
        background: "#6b7280",
        animation: "typingBounce 1.2s infinite ease-in-out",
      }}
    />

    <span
      className="dot"
      style={{
        width: 8,
        height: 8,
        borderRadius: "50%",
        background: "#6b7280",
        animation: "typingBounce 1.2s infinite ease-in-out",
        animationDelay: "0.15s",
      }}
    />

    <span
      className="dot"
      style={{
        width: 8,
        height: 8,
        borderRadius: "50%",
        background: "#6b7280",
        animation: "typingBounce 1.2s infinite ease-in-out",
        animationDelay: "0.3s",
      }}
    />
  </span>
</div>
                ) : (
                  <div className="chat-input">
                    {/* <button className="icon-btn" disabled={isBotTyping}>
                      <PaperClipOutlined style={{ fontSize: 20 }} />
                    </button> */}

                    <input
                      disabled={isBotTyping}
                      type="text"
                      placeholder={"Type your question here..."}
                      value={inputValue}
                      className="w-[40%]"
                      onChange={(e) => {
                        // resetIdleTimer();
                        setInputValue(e.target.value);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") handleSend();
                      }}
                      style={{
                        direction: lang === "ar" ? "rtl" : "ltr",
                        textAlign: lang === "ar" ? "right" : "left",
                      }}
                    />
                    <button
                      disabled={isBotTyping}
                      className="send-btn"
                      onClick={handleSend}
                    >
                      <SendOutlined style={{ fontSize: 20, color: "white" }} />
                    </button>
                  </div>
                )}
              </>
            )}
          </>
          {/* )} */}
        </div>
      </Modal>
    </>
  );
};

export default Chat;






